import { optionTitle_retentionPolicies } from './RetentionPoliciesOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let RetentionPoliciesOption: LazyOption = createLazyOption(
    {
        key: 'retentionPoliciesOption',
        titleStringKey: optionTitle_retentionPolicies,
        hideTitleInFullOptions: true,
        searchTermsStringKey: optionTitle_retentionPolicies,
        isHidden: () => {
            return isConsumer() || !getUserConfiguration().RetentionPolicyTags;
        },
        allowedOptionKeys: ['RetentionPolicies'],
    },
    lazyFullModule,
    m => m.default
);
export default RetentionPoliciesOption;
